import { ElementFactory } from './ElementFactory.js';
import { ContainerController } from './ContainerController.js';
export class ContentConstructor {
    constructor(_parent, _watcher) {
        this._parent = _parent;
        this._watcher = _watcher;
    }
    clear() {
        this._parent.innerHTML = '';
    }
    create_label(label) {
        const element = ElementFactory.create_label(label).element;
        this._parent.appendChild(element);
    }
    create_container(...args) {
        const { element, content } = ElementFactory.create_container(...args);
        this._parent.appendChild(element);
        return new ContainerController(content, this._watcher);
    }
    create_button(...args) {
        const { element, set_enabled } = ElementFactory.create_button(...args);
        this._parent.appendChild(element);
        return { set_enabled: set_enabled };
    }
    create_input(...args) {
        const { element, set_enabled, handler } = ElementFactory.create_input(...args);
        this._parent.appendChild(element);
        return { set_enabled: set_enabled, handler: handler };
    }
    create_vector3(...args) {
        const { element, set_enabled, handler } = ElementFactory.create_vector3(...args);
        this._parent.appendChild(element);
        return { set_enabled: set_enabled, handler: handler };
    }
    create_color3(...args) {
        const { element, set_enabled, handler } = ElementFactory.create_color3(...args);
        this._parent.appendChild(element);
        return { set_enabled: set_enabled, handler: handler };
    }
    create_select_menu(...args) {
        const { element, set_enabled, handler } = ElementFactory.create_select_menu(...args);
        this._parent.appendChild(element);
        return { set_enabled: set_enabled, handler: handler };
    }
    create_setter(...args) {
        const { element, set_enabled } = ElementFactory.create_setter(...args);
        this._parent.appendChild(element);
        return { set_enabled: set_enabled };
    }
    create_getter(...args) {
        const { element, set_enabled } = ElementFactory.create_getter(...args);
        this._parent.appendChild(element);
        return { set_enabled: set_enabled };
    }
    create_vector3_setter(...args) {
        const { element, set_enabled } = ElementFactory.create_vector3_setter(...args);
        this._parent.appendChild(element);
        return { set_enabled: set_enabled };
    }
    create_vector3_getter(...args) {
        const { element, set_enabled } = ElementFactory.create_vector3_getter(...args);
        this._parent.appendChild(element);
        return { set_enabled: set_enabled };
    }
    create_color3_setter(...args) {
        const { element, set_enabled } = ElementFactory.create_color3_setter(...args);
        this._parent.appendChild(element);
        return { set_enabled: set_enabled };
    }
    create_color3_getter(...args) {
        const { element, set_enabled } = ElementFactory.create_color3_getter(...args);
        this._parent.appendChild(element);
        return { set_enabled: set_enabled };
    }
}
//# sourceMappingURL=ContentConstructor.js.map